import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-logo-dark',
  templateUrl: './icon-logo-dark.component.html',
  styles: []
})
export class IconLogoDarkComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
